import { render, staticRenderFns } from "./FeedAlertList.vue?vue&type=template&id=2985b24a&"
import script from "./FeedAlertList.vue?vue&type=script&lang=js&"
export * from "./FeedAlertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports